<template>
  <div>
    <form id="delete" @submit.prevent="showModal = true">
        <input type="submit" class="submit" v-bind:value="$t('admin.adminPlanDelete.button.delete')">
    </form>
    <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('admin.adminPlanDelete.modal.header', {name: plan.name})" @close="showModal = false">
      <p class="modal-text" v-html="$t('admin.adminPlanDelete.modal.text')"></p>
      <a v-on:click.prevent="deletePlanGroupProject" class="button" href="#">{{ $t("admin.adminPlanDelete.modal.button") }}</a>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { adminService } from '@/services/admin.service'

export default {
  props: ['plan'],
  name: 'AdminPlanDelete',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deletePlanGroupProject: function () {
      adminService.groupList(this.plan.id).then(async groups => {
        for(let group of groups){
          await this.deleteGroupProject(group)
        }
        this.deletePlan()
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    },
    deleteGroupProject: function (group) {
      return new Promise(async (resolve) => {
        await adminService.projectList(group.id).then(async projects => {
          for(let project of projects){
            await this.deleteProject(project)
          }
          await this.deleteGroup(group)
        }).catch((err) => {
          console.error('Something went wrong: ', err)
        })
        resolve()
      })
    },
    deleteProject: function (project) {
      return new Promise(async (resolve) => {
        await adminService.projectDelete(project.id).then(() => {
          console.log('delete project: ' + project.name)
        }).catch((err) => {
          console.error('Unable to delete project: ', err)
        })
        resolve()
      })
    },
    deleteGroup: function (group) {
      return new Promise(async (resolve) => {
        await adminService.groupDelete(group.id).then(() => {
          console.log('delete group: ' + group.name)
        }).catch((err) => {
          console.error('Unable to delete group: ', err)
        })
        resolve()
      })
    },
    deletePlan: function () {
      adminService.planDelete(this.plan.id).then(() => {
          console.log('delete plan: ' + this.plan.name)
          this.showModal = false
          this.$router.push('/admin/planList/')
        }).catch((err) => {
        console.error('Unable to delete plan: ', err)
      })
    }
  }
}
</script>
